import { Quote } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section className="section-pad">
      <div className="container-cb">
        <div className="max-w-3xl">
          <div className="overline mb-4 flex items-center gap-3"><span className="gold-divider" /> {t.testimonials.overline}</div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-cb-primary">{t.testimonials.title}</h2>
        </div>
        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {t.testimonials.items.map((it, i) => (
            <figure key={i} className="card-cb p-7" data-testid={`testimonial-${i}`}>
              <Quote size={28} className="text-cb-gold" />
              <blockquote className="mt-4 text-cb-primary leading-relaxed" style={{ fontFamily: "Outfit" }}>&ldquo;{it.q}&rdquo;</blockquote>
              <figcaption className="mt-5 text-sm text-cb-secondary border-t border-cb-primary/10 pt-4">{it.a}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
